module.exports = __webpack_public_path__ + "img/mail.dd73f5f8.svg";